/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const selectedPolicyEntitiesFormData = (state: { policyEntities: any; }) => state.policyEntities.entityFormData;
export const getEntitiesList = (state: { policyEntities: any; }) => state.policyEntities.entitiesList;
export const getAttributesList = (state: { policyEntities: any; }) => state.policyEntities.attributeList;
export const getAttributes = (state: { policyEntities: any; }) => state.policyEntities.attributes;
export const getAttributesFormError = (state: { policyEntities: any; }) => state.policyEntities.attributesFormError;
export const getColumnAttributes = (state: { policyEntities: any; }) => state.policyEntities.columnAttributes;
export const getColumnAttributesFormError = (state: { policyEntities: any; }) => state.policyEntities.columnAttributesFormError;
export const getEntitiesFormError = (state: { policyEntities: any; }) => state.policyEntities.entityFormError;
export const getResourceNSSelector = (state: { policyEntities: any; }) => state.policyEntities.resourceNS;
export const getResourcesSelector = (state: { policyEntities: any; }) => state.policyEntities.resources;
export const getDPModelSelector = (state: { policyEntities: any; }) => state.policyEntities.dpModelList;
export const getRemoteDataUrlObjectSelector = (state: { policyEntities: any; }) => state.policyEntities.remoteDataUrlObject;
export const getResourcePaginationSelector = (state: { policyEntities: any; }) => state.policyEntities.resourcePagination;
export const getRemoteDataUrlResponseSelector = (state: { policyEntities: any; }) => state.policyEntities.remoteDataUrlResponse;